import history from '../history'
import { fixedNode } from '../common/node'
import { store } from "../store";
export * from './asyncs'

export const setInitialPosition = (height, width, number) => ({
  type: 'INITIAL_POSITION',
  height: height, width: width, number: number
});

export const clickNode = (event, id, number, x, y, page) => {
  if(Number(number.slice(0, 1)) > 0 &&
    store.getState().client.fetchNodeNumber.length >= number.length) {
    if(number.length === 1) {
      history.push('/')
    }
    return({ type: null })
  }
  if( !fixedNode(id) && id && number.indexOf('e') !== 0 && number.indexOf('m') !== 0) {
    history.push('/nodes/' + id)
  }

  if( store.getState().server.contents[id].stamp) {
    return({ type: null })
  }

  return({
    type: 'CLICK_NODE',
    id: id, number: number, x: x, y: y, page: page,
    event
  })
};

export const resetClient = () => ({
  type: 'RESET_CLIENT'
});

export const handleMouseDown = event => {
  if( (window.location.pathname === '/about') || (window.location.pathname === '/help')){
    return({ type: null })
  }
  return({
    type: 'HANDLE_MOUSE_DOWN',
    event
  })
};

export const handleMouseMove = (event, number) => ({
  type: 'HANDLE_MOUSE_MOVE',
  number: number,
  event
});

export const handleMouseUp = () => ({
  type: 'HANDLE_MOUSE_UP'
});

export const openNode = number => ({
  type: 'OPEN_NODE',
  number: number
});

export const closingNode = number => ({
  type: 'CLOSING_NODE',
  number: number
});

export const closeNode = (id, number, root) => ({
  type: 'CLOSE_NODE',
  id: id, number: number, root: root
});

export const previousPage = (number, root) => ({
  type: 'PREVIOUS_PAGE',
  number: number, root: root
});

export const previousUserPage = () => ({
  type: 'PREVIOUS_USER_PAGE',
});

export const previousLikedPage = () => ({
  type: 'PREVIOUS_LIKED_PAGE',
});

export const setLocale = locale => ({
  type: 'SET_LOCALE',
  locale: locale
});

export const clickWidget = (event, number) => ({
  type: 'CLICK_WIDGET', number: number,
  event
});

export const callWidget = event => ({
  type: 'CALL_WIDGET',
  event
});

export const setZoom = (event, value) => ({
  type: 'SET_ZOOM', value: value,
  event
});



// WEBPACK FOOTER //
// ./src/actions/index.js